import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $insertNodeToNearestRoot } from "@lexical/utils";
import {
  COMMAND_PRIORITY_EDITOR,
  createCommand,
  LexicalCommand,
} from "lexical";
import { useEffect } from "react";

import { $createAparatNode, AparatNode } from "../../nodes/AparatNode";

export const INSERT_APARAT_COMMAND: LexicalCommand<string> = createCommand(
  "INSERT_APARAT_COMMAND"
);

export default function AparatPlugin(): JSX.Element | null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!editor.hasNodes([AparatNode])) {
      throw new Error("AparatPlugin: AparatNode not registered on editor");
    }

    return editor.registerCommand<string>(
      INSERT_APARAT_COMMAND,
      (payload) => {
        const aparatNode = $createAparatNode(payload);
        $insertNodeToNearestRoot(aparatNode);

        return true;
      },
      COMMAND_PRIORITY_EDITOR
    );
  }, [editor]);

  return null;
}
